import { render, staticRenderFns } from "./add.vue?vue&type=template&id=dabb611e&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=dabb611e&prod&lang=css&"
import style1 from "./add.vue?vue&type=style&index=1&id=dabb611e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabb611e",
  null
  
)

export default component.exports